import {
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
  HttpStatusCode,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { Observable } from "rxjs";
import { ERROR_MESSAGE_HANDLER } from "../../../interceptor/http.interceptor";

@Injectable()
export class SubcategoryHttpInterceptor implements HttpInterceptor {
  constructor(
    private translocoService: TranslocoService,
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const newRequest = request.clone({
      context: request.context.set(ERROR_MESSAGE_HANDLER, this.getMessageForStatus)
    });

    return next.handle(newRequest);
  }

  private getMessageForStatus = (error: HttpErrorResponse) => {
    // Returning a null message will result in falling back to the global handler
    // for mapping status codes to error messages
    let message: Observable<string> | null = null;

    switch (error.status) {
      case HttpStatusCode.Forbidden:
        message = this.translocoService.selectTranslate('subcategory-errors.permission')
        break;
      case HttpStatusCode.BadRequest:
      case HttpStatusCode.UnprocessableEntity:
      case HttpStatusCode.NotFound:
        message = this.translocoService.selectTranslate('subcategory-errors.invalid')
        break;
    }

    return message;
  }
}
